/**
 * The account endpoints of the website Worker, as the shell calls them.
 *
 * The signed-in shell asks who the browser is and signs it out; the public
 * pages submit the forms. Both go through `accountRequest`, so neither is a
 * second way to build one.
 */

/**
 * A stalled account route left the button dead and the card silent. Every
 * account request carries a deadline, and the refusal says which of the
 * two things happened rather than leaving a person to guess.
 */
const ACCOUNT_TIMEOUT_MS = 30_000;

/*
 * One place an account request is built, so the timeout is not something each
 * caller has to remember. `GET` is a parameter rather than inferred from the
 * path: a request's method is not a property of its address.
 */
export async function accountRequest(
  path: string,
  body?: Record<string, unknown>,
  method: 'GET' | 'POST' = 'POST',
): Promise<Response> {
  return fetch(path, {
    method,
    headers: { 'content-type': 'application/json' },
    signal: AbortSignal.timeout(ACCOUNT_TIMEOUT_MS),
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
}

export function accountUnreachableMessage(reason: unknown): string {
  const timedOut = reason instanceof DOMException && reason.name === 'TimeoutError';
  return timedOut
    ? 'The account service did not answer in time. Try again.'
    : 'The account service is unreachable. Check the site Worker is running.';
}
